import { Get, Post } from "./index";


class NotEnoughInformationError extends Error {
    constructor(message) {
        super(message);
        this.name = 'NotEnoughInformationError';
    }
}

class TariffLogicError extends Error {
    constructor(message) {
        super(message);
        this.name = 'TariffLogicError';
    }
}

class VehicleBlockedError extends Error {
    constructor(message) {
        super(message);
        this.name = 'VehicleBlockedError';
    }
}

class OrderDuplicationError extends Error {
    constructor(message) {
        super(message);
        this.name = 'OrderDuplicationError';
    }
}

let priceController;

const GetPrice = (vehicleId, stationFromId, stationToId, count) => {
    if (priceController) {
        priceController.abort("deduplication")
    }
    priceController = new AbortController()
    return Get("payments", {
        vehicle_id: vehicleId,
        station_from_id: stationFromId,
        ...stationToId ? { station_to_id: stationToId } : {},
        count,
    }, priceController.signal).catch(error => {
        if (error instanceof Response) {
            switch (error.status) {
                case 416:
                    throw new NotEnoughInformationError();
                case 419:
                    throw new TariffLogicError();

            }
        }
    })
}

const Pay = (vehicleId, stationFromId, stationToId, count, price, autoPayment, ignoreOrderDuplication = false, unblockCode = null) => {
    return Post("payments", null, {
        vehicle_id: vehicleId,
        station_from_id: stationFromId,
        ...stationToId ? { station_to_id: stationToId } : {},
        count,
        price,
        auto_payment: autoPayment,
        ignore_order_duplication: ignoreOrderDuplication,
        unblock_code: unblockCode,
    }).catch(error => {
        if (error instanceof Response) {
            switch (error.status) {
                case 420:
                    throw new VehicleBlockedError();
                case 421:
                    throw new OrderDuplicationError();
            }
        }
    })
}

export { GetPrice, Pay, NotEnoughInformationError, TariffLogicError, VehicleBlockedError, OrderDuplicationError }